export default __webpack_public_path__ + "static/media/favorite_2.2b215a36.jpg";